import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response && error.request) {
      error.message = 'Falha ao conectar com a API. Verifique se o backend está rodando em ' +
        `${api.defaults.baseURL || 'http://localhost:8001'} e se o navegador consegue alcançá-lo.`;
    }
    return Promise.reject(error);
  }
);

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function asObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

export default api;
